<template>
  <div class="warpper">
    <swiper :options="swiperOption" class="swiper-container">
      <!-- slides -->
      <swiper-slide class="swiper-item" v-for='(item, index) in resverSwiperList' :key='index'>
        <!-- <img class='swiper-img' :src='item.imgUrl' alt="去哪儿门票" /> -->
        <div class="nav-bar">
          <div class="nav-item" v-for="ite in item" :key="ite.text"  @click="onNavigate(ite)">
            <img :src="ite.icon" alt="快捷菜单" style="border-radius: 50%;border: 1px solid #fe003b">
            <p class="ellipsis" v-text="ite.name"></p>
          </div>
        </div>
      </swiper-slide>
      <!-- Optional controls ,显示小点-->
      <div class="swiper-pagination data-swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
export default {
  name: 'AutoScrollNav',
  props:{
    cateList:Array  ,
  },
  data () {
    return {
      swiperOption: {
        pagination: '.swiper-pagination',
        loop: false,
        autoplay: 0,
        speed: 1000
      }
    }
  },
  computed: {
    resverSwiperList () {
      const dataSource = this.cateList
      return this.splitArr(dataSource, 10)
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log(this.resverSwiperList)
    // console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
  methods: {
    // 跳转
    onNavigate (item) {
      if (item.type) {
        this.$router.push({
          path:item.url
        })
      }else{
        this.$router.push({
          path: '/productNavList',
          query: { id: item.id, name: item.name}
        })
      }
    },
    splitArr (data, senArrLen) {
      // 处理成len个一组的数据
      const dataLen = data.length
      const arrOuterLen = dataLen % senArrLen === 0 ? dataLen / senArrLen : parseInt((dataLen / senArrLen) + '') + 1
      const arrSecLen = dataLen > senArrLen ? senArrLen : dataLen // 内层数组的长度
      const arrOuter = new Array(arrOuterLen) // 最外层数组
      let arrOuterIndex = 0 // 外层数组的子元素下标
      for (let i = 0; i < dataLen; i++) {
        if (i % senArrLen === 0) {
          arrOuterIndex++
          let len = arrSecLen * arrOuterIndex
          // 将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
          arrOuter[arrOuterIndex - 1] = new Array(dataLen % senArrLen)
          if (arrOuterIndex === arrOuterLen) { // 最后一组
            dataLen % senArrLen === 0 ? len = dataLen % senArrLen + senArrLen * arrOuterIndex : len = dataLen % senArrLen + senArrLen * (arrOuterIndex - 1)
          }
          let arrSecIndex = 0 // 第二层数组的索引
          for (let k = i; k < len; k++) { // 第一层数组的开始取决于第二层数组长度*当前第一层的索引
            arrOuter[arrOuterIndex - 1][arrSecIndex] = data[k]
            arrSecIndex++
          }
        }
      }
      console.log(arrOuter)
      return arrOuter
    }
  }
}
</script>
<style lang="scss">
  .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 0;
  }
.data-swiper-pagination {
  .swiper-pagination-bullet {
    width: 30px;
    margin: 0 !important;
    border-radius: 0;
    background-color: #999999;
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .swiper-pagination-bullet-active {
    background:#fe003b; // 修改选中的颜色
  }
}
</style>
<style scoped lang="scss">
.swiper-container {
  height: 12rem; // 调整整体高度
  .nav-bar {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    height: 12rem;
    .nav-item {
      width: 20%;
      /*flex: 0 0 20%;*/
      margin:0.6rem 0;
      text-align: center;
      img {
        width: 2.4rem;
        height: 2.4rem;
      }
      p {
        margin: 0.5rem 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/modules/AutoScrollNav.vue